import Parse from "parse";

export function requestDevicePairing(myJID, requestedJID) {
  return Parse.Cloud.run("requestDevicePairing", { myJID, requestedJID });
}
